const HOSTNAME = window.location.hostname;
const ABBR = HOSTNAME.split('.')[0];

const BASE = `/gw/${ABBR}/assets`;
export const assets = {
    image: (name) => `${BASE}/images/${name}`,
    font:  (name) => `${BASE}/fonts/${name}`,
    icon:  (name) => `${BASE}/icons/${name}`,
    fileIcon: (name) => `${BASE}/icons/fileTypes/${name}`,
};
